// @flow
import React from 'react';
import Experiment, {On} from '@homeaway/react-experiment';
import LeadCarosuelContainer from './LeadCarouselContainer';
import {VRBO_SERP_MAB_RECENTLY_VIEWED_CAROUSEL} from '../../abacus/experiments';

type Props = {
    placement: string,
    resultCount?: number,
    showRecentlyViewedCarousel?: boolean
};

const LeadCarouselContainerWrapper = (props: Props) => {
    return (
        <Experiment name={VRBO_SERP_MAB_RECENTLY_VIEWED_CAROUSEL}>
            <On>
                <LeadCarosuelContainer {...props} />
            </On>
        </Experiment>
    );
};

export default LeadCarouselContainerWrapper;
